import { GameBetCountDto } from '@app/store/api/gameApi';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LotteryGameCreationState {
  gamesBetsCountList: GameBetCountDto[];
}

const initialState: LotteryGameCreationState = {
  gamesBetsCountList: [],
};

const lotteryGameCreationSlice = createSlice({
  name: 'lotteryGameCreation',
  initialState,
  reducers: {
    setGamesBetsCountList: (state, { payload }: PayloadAction<GameBetCountDto[]>) => {
      state.gamesBetsCountList = payload;
    },

    incrementGamesBetCount: (state, { payload }: PayloadAction<string>) => {
      const index = state.gamesBetsCountList.findIndex((item) => item.bet === payload);
      if (index !== -1) {
        state.gamesBetsCountList[index].gamesCount += 1;
      }
    },

    resetGamesBetsCountList: (state) => {
      state.gamesBetsCountList = [];
    },
  },
});

export const { setGamesBetsCountList, incrementGamesBetCount, resetGamesBetsCountList } =
  lotteryGameCreationSlice.actions;

export default lotteryGameCreationSlice.reducer;
